import { Component } from '@angular/core';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss']
})
export class OfferComponent {

  items =[
    {
      icon:'mdi-button-cursor',
      title:'Visual Drag & Drop Interface',
      description:'Build custom apps entirely visually. No coding required.  The WYSIWYG editor ensures your design translates perfectly into the final product.'
    },{
      icon:'mdi-view-grid-plus',
      title:'Rapid Application Development',
      description:'Leverage pre-built components and templates to significantly accelerate development cycles, enabling faster time-to-market for your mobile apps.'
    },{
      icon:'mdi-responsive',
      title:'Develop Responsive Applications',
      description:'Enable businesses to tailor the appearance and branding of the product to align with their corporate identity'
    },{
      icon:'mdi-cog-play-outline',
      title:'Workflow Automation & Integration Capabilities',
      description:'Automate repetitive tasks and streamline business processes within your mobile apps. Seamlessly connect your apps to existing systems (CRM, ERP) for a unified data landscape.'
    },{
      icon:'mdi-shield-lock-outline',
      title:'Secure & Scalable Solutions',
      description:'Build secure enterprise-grade mobile applications with granular access control. The platform scales to meet your growing business needs.'
    },{
      icon:'mdi-compare-horizontal',
      title:'Cross-Platform Compatibility',
      description:' Develop mobile apps that function flawlessly across various devices and operating systems(android and iOS), ensuring wider accessibility for your users.'
    }
  ]

}
